export default function PlayNextIcon() {
  return (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.10667 14.52L9.8 9.09333C10.5467 8.56 10.5467 7.44 9.8 6.92L2.10667 1.48C1.21333 0.866667 0 1.49333 0 2.57333V13.4267C0 14.5067 1.21333 15.1333 2.10667 14.52ZM13.3333 1.33333V14.6667C13.3333 15.4 13.9333 16 14.6667 16C15.4 16 16 15.4 16 14.6667V1.33333C16 0.6 15.4 0 14.6667 0C13.9333 0 13.3333 0.6 13.3333 1.33333Z" />
    </svg>
  );
}
